import { CircleExclamation } from "@/components/ui/icons/Circle-exclamation";
import { colorsForeground } from "@/styles/tokens/colors/colorsForeground";

interface ErrorAlertProps {
	color?: string;
	testId?: string;
}

export const ErrorAlert = ({
	color = colorsForeground.fg_disabled_subtle_dark,
	testId = "icon_error_alert",
}: ErrorAlertProps) => (
	<span data-testid={testId} style={{ position: "absolute", right: "8px" }}>
		<CircleExclamation stroke={color} />
	</span>
);
